import { Component, OnInit } from '@angular/core';
import { IHistory, ITimelineVisit } from "./se-timeline.models";
import { Subscription } from "rxjs";
import { Store } from "@ngrx/store";
import { seTimelineComponentSetPatient } from "./redux/se-timeline.actions";
import { Actions, ofType } from "@ngrx/effects";
import { SearchFormType } from "../search-page/search-page-type.enum";

@Component({
    selector: 'se-timeline',
    templateUrl: './se-timeline.component.html',
    styleUrl: './se-timeline.component.scss'
})
export class SeTimelineComponent implements OnInit {

    clinicalHistory : ITimelineVisit[] = [];
    groupedData : IHistory[] = [];
    selectedPatientSubscription : Subscription;
    formType : SearchFormType;
    selectedPatientId : string;
    constructor (
        private actions : Actions,
        private store : Store
    ) {
        this.listenForStoreEvents();
    }

    ngOnInit () : void {
        this.clinicalHistory = [
            { date: new Date("2017-02-16"), description: "visit 1" },
            { date: new Date("2017-12-17"), description: "visit 2" },
            { date: new Date("2018-05-18"), description: "visit 3" },
            { date: new Date("2020-05-19"), description: "visit 4" },
            { date: new Date("2021-05-20"), description: "visit 5" },
            { date: new Date("2021-05-21"), description: "visit 6" },
            { date: new Date("2021-05-22"), description: "visit 7" },
            { date: new Date("2017-04-16"), description: "visit 8" },
            { date: new Date("2017-03-17"), description: "visit 9" },
            { date: new Date("2018-02-18"), description: "visit 10" },
            { date: new Date("2020-05-30"), description: "visit 11" },
            { date: new Date("2021-05-15"), description: "visit 12" },
            { date: new Date("2021-06-27"), description: "visit 13" },
            { date: new Date("2021-03-29"), description: "visit 14" },
        ];
        this.groupedData = this.groupVisitsByYear(this.clinicalHistory);
    }

    listenForStoreEvents () {
        this.selectedPatientSubscription = this.actions.pipe(ofType(seTimelineComponentSetPatient)).subscribe((action) => {
            // TODO_DGS fare chiamata verso metodo di recupero storia clinica
            // action = { formType: any + patientId: string }
            this.formType = action.formType as SearchFormType;
            this.selectedPatientId = action.patientId;
        });
    }

    private groupVisitsByYear (dataArray : ITimelineVisit[]) : IHistory[] {
        dataArray.sort((a, b) => a.date.getTime() - b.date.getTime());
        const groupedData : { [year : string] : ITimelineVisit[]; } = {};

        dataArray.forEach(item => {
            const year = item.date.getFullYear().toString();
            if (!groupedData[year]) {
                groupedData[year] = [];
            }
            groupedData[year].push(item);
        });

        const result = Object.entries(groupedData).map(([year, visits]) => ({
            year,
            visits
        }));

        return result;
    }
}
